import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box } from '@mui/material';
import { IoClose } from "react-icons/io5";

export default function RemarksDialog(props) {
 
console.log("data",props.data);

  return (
    <React.Fragment>
      
      <Dialog
        open={props.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{fontSize:'18px'}} id="alert-dialog-title">
          {"Remarks"}
        </DialogTitle>
        <Box
            sx={{position:'absolute',top:5,right:5,cursor:'pointer',fontSize:'22px'}}
            onClick={props.handleClose}
        >
            <IoClose />

        </Box>
        <DialogContent sx={{pt:0}}>
          <DialogContentText id="alert-dialog-description">
            <table>
                {
                    props.data && props.data["maker_remarks"]?
                    <tr>
                        <th style={{textAlign:'left'}}>Maker Remarks</th>
                        <td></td>
                        <td style={{textAlign:'left'}}>{props.data["maker_remarks"]}</td>
                    </tr>
                    :
                    null

                }
                {
                    props.data && props.data["checker_remarks"]?
                    <tr>
                        <th style={{textAlign:'left'}}>Maker Remarks</th>
                        <td></td>
                        <td style={{textAlign:'left'}}>{props.data["checker_remarks"]}</td>
                    </tr>
                    :
                    null

                }
                {
                    props.data && props.data["1_remarks"]?
                    <tr>
                        <th style={{textAlign:'left'}}>Checker Remarks</th>
                        <td></td>
                        <td style={{textAlign:'left'}}>{props.data["1_remarks"]}</td>
                    </tr>
                    :
                    null

                }
            </table>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
         
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
